import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

import KidsCoding from "./Pages/Pdf";

function App() {
  return (
    <Router>
      <div className="font-poppins overflow-x-clip">
        <main className="mt-[5%] md:mt-[5%] min-h-fit md:min-h-screen mx-auto overflow-x-clip">
          <Routes>
            <Route path="/" element={<KidsCoding />} />
          </Routes>
        </main>
        <footer></footer>
      </div>
    </Router>
  );
}

export default App;
